import { render, staticRenderFns } from "./CoursesApproval.vue?vue&type=template&id=c2f0fae0&scoped=true&"
import script from "./CoursesApproval.vue?vue&type=script&lang=js&"
export * from "./CoursesApproval.vue?vue&type=script&lang=js&"
import style0 from "./CoursesApproval.vue?vue&type=style&index=0&id=c2f0fae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f0fae0",
  null
  
)

export default component.exports